module.exports = __webpack_public_path__ + "static/Young-Adults-Guide__Takeaways-bb6571a3a5e99977da617916d7b77850.pdf";